import React, { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import errorReporter from '../../services/errorReporter.js';
import Error404Page from '../../Pages/Error404Page/Error404Page.js';
import { ErrorScreen } from './ErrorBoundary.js';

const RELOAD_KEY = 'esep.chunkReloadAt';

// after a deploy old lazy chunks are gone — reload once to pick up the new build
const isChunkError = (e) =>
  e?.name === 'ChunkLoadError' || /Loading (CSS )?chunk|dynamically imported module/i.test(e?.message || '');

function shouldReloadForChunk(error) {
  if (!isChunkError(error)) return false;
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY)) || 0;
    if (Date.now() - last < 10_000) return false;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    return true;
  } catch {
    return false;
  }
}

function RouteError({ inline }) {
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;

  useEffect(() => {
    if (notFound) return;
    if (shouldReloadForChunk(error)) {
      window.location.reload();
      return;
    }
    errorReporter.report({
      message: error?.message || error?.statusText || String(error),
      stack: error?.stack || null,
      metadata: { type: 'route_error', status: error?.status ?? null },
    });
    errorReporter.flush();
  }, [error, notFound]);

  if (notFound) return <Error404Page />;
  return <ErrorScreen error={error} inline={inline} />;
}

export default RouteError;
